import { FC } from "react";

interface IconWhatsappProps {
  className?: string;
  width?: string | number;
  height?: string | number;
  fill?: string;
}

const IconWhatsapp: FC<IconWhatsappProps> = ({ className, width = "22", height = "22", fill = "white" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8713 3.02951C19.8902 3.98525 20.6926 5.09426 21.2517 6.32951C21.8287 7.61885 22.1263 8.98033 22.1172 10.3959C22.1172 11.8025 21.8197 13.1729 21.2426 14.4533C20.6836 15.6885 19.8812 16.7975 18.8623 17.7533C17.8435 18.709 16.6623 19.4484 15.3459 19.9713C13.9844 20.5123 12.5418 20.7828 11.0541 20.7828C9.4582 20.7828 7.93443 20.4762 6.50083 19.8631L1.70409 22L2.60573 17.0861C0.919663 15.2107 0 12.8484 0 10.3869C0 8.98033 0.297559 7.60984 0.874608 6.32951C1.43362 5.09426 2.23607 3.98525 3.25493 3.02951C4.27378 2.07377 5.45493 1.33443 6.77132 0.811475C8.13279 0.270492 9.57543 0 11.0631 0C12.5508 0 13.9935 0.270492 15.3549 0.811475C16.6713 1.33443 17.8525 2.08279 18.8713 3.02951ZM14.4986 11.9917C14.742 12.0819 15.0846 12.2261 15.5535 12.4606C15.6799 12.5255 15.8129 12.5801 15.9469 12.6351C16.1664 12.7252 16.3888 12.8165 16.5903 12.9565C16.7526 13.1729 16.7977 13.3532 16.6895 13.8311C14.5617 19.3311 4.10266 11.3515 5.84282 7.15893C6.13135 6.50073 6.83459 5.23843 8.06082 5.86958C8.25252 5.96543 8.33279 6.16875 8.41268 6.37112C8.45303 6.47332 8.49328 6.57528 8.54774 6.66302C8.6664 6.91164 8.79568 7.19567 8.90673 7.43966C8.97289 7.585 9.03257 7.71614 9.0797 7.81712C9.09451 7.87081 9.12414 7.93019 9.15705 7.99614C9.28441 8.25139 9.46081 8.6049 9.01657 9.10647C8.97818 9.18004 8.89213 9.27291 8.79828 9.3742C8.62759 9.5584 8.4311 9.77046 8.44855 9.94499C8.59281 10.2065 9.26003 11.1802 9.62068 11.5229C10.4322 12.3073 11.469 13.0737 12.5871 13.2901C12.8509 13.1898 13.1055 12.8332 13.3508 12.4896C13.5247 12.2461 13.6938 12.0091 13.8584 11.8745C13.9663 11.7897 14.2455 11.896 14.42 11.9624C14.4497 11.9737 14.4763 11.9839 14.4986 11.9917Z"
        fill={fill ? fill : "white"}
      />
    </svg>
  );
};

export default IconWhatsapp;
